import { render, staticRenderFns } from "./ModuleConfirmation.vue?vue&type=template&id=fadb653a&scoped=true"
import script from "./ModuleConfirmation.vue?vue&type=script&lang=js"
export * from "./ModuleConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ModuleConfirmation.vue?vue&type=style&index=0&id=fadb653a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadb653a",
  null
  
)

export default component.exports